import { render, staticRenderFns } from "./Magasin_Produit.vue?vue&type=template&id=246f06ce&"
import script from "./Magasin_Produit.vue?vue&type=script&lang=js&"
export * from "./Magasin_Produit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports